/**
 * 2007-2017 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2017 PrestaShop SA
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */

 
import 'bootstrap/js/src/util';
import 'bootstrap/js/src/alert';
import 'bootstrap/js/src/button';
import '../node_modules/bootstrap/js/src/collapse.js';
import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/dropdown';
import 'bootstrap/js/src/modal';
import 'bootstrap/js/src/popover';
import 'bootstrap/js/src/tab';
import 'bootstrap/js/src/toast';
import 'bootstrap/js/src/tooltip';
import 'bootstrap-touchspin';
import './lib/slick.min';
import './lib/jquery.hoverIntent.min';
import SlickSlider from './components/slick';

import './responsive';
import './checkout';
import './customer';
import './listing';
import './product';
import './cart';

import Form from './components/form';
import TopMenu from './components/top-menu';

import prestashop from 'prestashop';
import EventEmitter from 'events';

import './components/block-cart';

import lazysizes from 'lazysizes'

import './lib/notify';
import './lib/bootstrap-input-spinner';


// "inherit" EventEmitter
for (var i in EventEmitter.prototype) {
  prestashop[i] = EventEmitter.prototype[i];
}

function addSpinner(param){
  $("article input[type='number']").inputSpinner({
    // button text/icons
    decrementButton: "<strong>-</strong>", 
    incrementButton: "<strong>+</strong>", 
    // class of input group
    groupClass: "input-group-spinner",
    // button class
    buttonsClass: "btn-outline-secondary",
    // button width
    buttonsWidth: "0.5em",
    // text alignment
    textAlign: "center",
    // delay in milliseconds
    autoDelay: 500, 
    // interval in milliseconds
    autoInterval: 100,
    // set this `true` to disable the possibility to enter or paste the number via keyboard
    buttonsOnly: true, 
    // the locale, per default detected automatically from the browser
    locale: navigator.language, 
    
    // the template of the input
    template: '<div class="input-group ${groupClass}">' +
      '<div class="input-group-prepend"><button style="min-width: ${buttonsWidth}" class="btn btn-decrement ${buttonsClass} btn-minus" type="button">${decrementButton}</button></div>' +
      '<input type="text" inputmode="decimal" style="text-align: ${textAlign}" class="form-control form-control-text-input"/>' +
      '<div class="input-group-append"><button style="min-width: ${buttonsWidth}" class="btn btn-increment ${buttonsClass} btn-plus" type="button">${incrementButton}</button></div>' +
      '</div>'
    
  });
  //some code
}



$(document).ready(() => {

  const addCartMessage = "Article ajouté au panier";


  const test = 270479;
  const form = new Form();
  let slickSlider = new SlickSlider();
  let topMenuEl = $('#_desktop_top_menu #top-menu');
  let topMenu = new TopMenu(topMenuEl);

  form.init();
  slickSlider.init();
  topMenu.init();

  //display input file content in custom file input BS
  $('.custom-file-input').on('change', function () {
    let fileName = $(this).val().split('\\').pop();
    $(this).next('.custom-file-label').addClass("selected").html(fileName);
  })

  addSpinner();

  // On récupère et detect l'evenement "updateProductList"
  if (typeof prestashop !== 'undefined') {
    prestashop.on(
      'updateProductList',
      function (event) {
        addSpinner();

      }
    );
  }

  // On récupère et detect l'evenement "updateCart"
  if (typeof prestashop !== 'undefined') {
    prestashop.on(
      'updateCart',
      function (event) {
        // on fait ça uniquement quand c'est une action "bouton" add to et que l'id du produit est "identifé"
        if (typeof event.reason.linkAction !== "undefined" && event.reason.linkAction == "add-to-cart") {
          if (event.reason.idProduct != undefined) {
            console.log(event.reason);
            // var test = $('article[data-item-id="274"]').contents()
            // this.cart.products[3].reference
            // On force à remettre à jour le champ "value" avec celui d'orgine = conditionement mini
            var input_origin_value = $("#quantity_wanted").attr('value');
            $('#quantity_wanted').val(input_origin_value);
            // on envois la notifucation "popup"
            //var product_reference = $('.product-reference span').html()
            $.notify( addCartMessage, "success");
            // On reset le bouton "ajax"
            $('.js-add-to-cart.is--loading').removeClass('is--loading');
            $('.js-add-to-cart').attr("disabled", false);

          }
        }

      }
    );
  }

});


document.addEventListener('lazyloaded', function (e) {
  $(e.target).parent().addClass('rc--lazyload');
});

